<div v-bind:class="[getClassName, getLoadingClass, getPersonalizeLoadingClass]">
  <div class="vld-parent">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
    >
    </loading>
  </div>
</div>
